import { rest } from '@0xtorch/core'
import { z } from 'zod'
import type { TestApiAuthentication } from '../types'
import { bitgetApiEndpoint } from './constants'
import { createPrivateGetHeaders } from './utils'

const responseSchema = z.object({
  code: z.string(),
  msg: z.string(),
  requestTime: z.number().int(),
  data: z.array(z.unknown()),
})

export const testBitgetApiAuthentication: TestApiAuthentication = async ({
  apiKey,
  apiSecret,
  apiPassword,
  proxy,
  proxyHeaders,
}) => {
  if (apiPassword === undefined) {
    return false
  }

  const url = new URL('/api/v2/account/all-account-balance', bitgetApiEndpoint)

  try {
    await rest(
      proxy === undefined
        ? url.toString()
        : `${proxy}${encodeURIComponent(url.toString())}`,
      {
        fetchOptions: {
          method: 'GET',
          headers: {
            ...proxyHeaders,
            ...(await createPrivateGetHeaders({
              apiKey,
              apiSecret,
              password: apiPassword,
              urlPath: url.pathname,
              query: '',
            })),
          },
        },
        schema: responseSchema,
      },
    )
    return true
  } catch {
    return false
  }
}
